// Customer requirements are descriptive; backend Variant mapping owns BOM and money.
document.querySelectorAll('[data-service-pdp]').forEach(root => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const requirements = root.querySelector('[data-service-requirements]');
  const dialog = root.querySelector('[data-quote-dialog]');
  const contact = dialog.querySelector('form');
  const controls = [...requirements.querySelectorAll('[data-label]')];
  const section = root.closest('.shopify-section');
  const nativePurchase = section?.querySelector('[data-service-native-form]');
  const nativeForm = nativePurchase?.querySelector('form');
  const purchaseSelection = () => {
    const option = root.querySelector('[data-service-configuration]')?.selectedOptions[0];
    return {
      id: option ? option.dataset.variant : root.dataset.nativeVariant,
      approved: (option ? option.dataset.servicePurchaseApproved : root.dataset.servicePurchaseApproved) === 'true',
      available: (option ? option.dataset.serviceAvailable : root.dataset.serviceAvailable) === 'true',
      key: option ? option.dataset.key : root.dataset.configurationKey
    };
  };
  const selections = () => controls.filter(el => el.value.trim()).map(el => [el.dataset.label, el.value.trim()]);
  const update = () => {
    controls.filter(el => el.hasAttribute('data-positive-integer')).forEach(el => {
      el.setCustomValidity(el.value && (!Number.isSafeInteger(Number(el.value)) || Number(el.value) < 1) ? 'Enter a whole number greater than zero' : '');
    });
    const brief = controls.filter(el => ['configuration','quantity','participants','area','environment','pitch'].includes(el.name) && el.value).map(el => el.name === 'area' ? `${el.value} m²` : el.name === 'quantity' ? `${el.value} ${root.dataset.billingUnit||''}`.trim() : el.value).join(' · ');
    root.querySelector('[data-inline-summary]').textContent = brief || 'Tell us about your display to prepare the service brief';
    root.querySelector('[data-sticky-summary]').textContent = brief || 'Project-based quotation';
    if (nativeForm) {
      const selected = purchaseSelection();
      const canBuy = selected.approved && selected.available && typeof nativePurchase.handleSubmit === 'function';
      nativePurchase.hidden = !selected.approved;
      section.querySelector('[data-service-inquiry]').hidden = selected.approved;
      root.querySelector('[data-open-quote]').hidden = selected.approved;
      root.querySelector('[data-service-sticky-purchase]').hidden = !selected.approved;
      nativeForm.querySelector('input[name="id"]').value = canBuy ? selected.id : '';
      const quantity = root.querySelector('[name="quantity"]')?.value || '1';
      nativeForm.querySelector('[data-service-cart-quantity]').value = quantity;
      nativePurchase.dataset.quantityDefault = quantity;
      const pending = nativePurchase.hasAttribute('data-absen-add-pending');
      const buyNow = nativePurchase.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
      if (buyNow) buyNow.hidden = !canBuy;
      nativePurchase.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = pending || !canBuy; });
      root.querySelectorAll('[data-service-purchase-action]').forEach(button => { button.disabled = pending || !canBuy; });
      const properties = [['Service', root.dataset.productTitle], ...selections(), ['_service_configuration', selected.key], ['_service_native_variant', selected.id]];
      nativeForm.querySelector('[data-service-line-properties]').replaceChildren(...properties.map(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = `properties[${name}]`; input.value = value;
        return input;
      }));
      const label = nativePurchase.querySelector('[ref="addToCartButton"]');
      const text = label?.querySelector('.add-to-cart-text');
      if (text) text.textContent = canBuy ? 'Add to cart' : 'Unavailable';
    }
    if (root.hasAttribute('data-service-pricing')) {
      const selected = root.querySelector('[data-service-configuration]')?.selectedOptions[0];
      // An explicit blank on a legacy option means quote; never use the root price.
      const unitPrice = selected ? selected.dataset.unitPrice : root.dataset.unitPrice;
      const displayPrice = unitPrice ? `${unitPrice} / ${root.dataset.priceUnit}` : 'Price on request';
      root.querySelector('[data-service-unit-price]').textContent = displayPrice;
      root.closest('.shopify-section')?.querySelectorAll('[data-service-price-value]').forEach(price => {
        price.textContent = displayPrice;
      });
      root.querySelector('[data-sticky-summary]').textContent = [brief, displayPrice].filter(Boolean).join(' · ');
    }
  };
  requirements.addEventListener('input', update);
  requirements.addEventListener('change', update);
  const open = () => {
    update();
    if (!requirements.reportValidity()) { requirements.scrollIntoView({behavior:'auto',block:'center'}); return; }
    const selectedConfiguration=root.querySelector('[data-service-configuration]')?.selectedOptions[0];
    const entries = [['Service',root.dataset.productTitle], ...selections()];
    const nativeVariant=selectedConfiguration?.dataset.variant||root.dataset.nativeVariant;
    const configurationKey=selectedConfiguration?.dataset.key||root.dataset.configurationKey;
    const summary = root.querySelector('[data-confirm-summary]');
    summary.replaceChildren(...entries.flatMap(([key,value]) => {
      const dt = document.createElement('dt'); dt.textContent = key;
      const dd = document.createElement('dd'); dd.textContent = value;
      return [dt,dd];
    }));
    root.querySelector('[data-contact-body]').value = entries.map(([k,v]) => `${k}: ${v}`).join('\n') + `\nConfiguration ID: ${configurationKey}\nNative variant reference: ${nativeVariant}\nPreferred dates are not confirmed bookings.`;
    dialog.showModal();
  };
  const submitPurchase = action => {
    update();
    const button = nativePurchase?.querySelector(action === 'buy' ? '[data-absen-buy-now]' : 'button[name="add"]');
    if (button && !button.disabled) nativeForm.requestSubmit(button);
  };
  if (nativeForm) {
    customElements.whenDefined('product-form-component').then(update);
    // Observe Horizon's public pending state so both entry points recover after failure.
    new MutationObserver(update).observe(nativePurchase, {attributes:true, attributeFilter:['data-absen-add-pending']});
    // Horizon dispatches on:submit at document capture, before form capture.
    // Validate inside its service action, then call the same native owner.
    nativePurchase.handleAbsenServiceSubmit = event => {
      event.preventDefault();
      update();
      const selected = purchaseSelection();
      if (typeof nativePurchase.handleSubmit !== 'function' || !selected.approved || !selected.available || !requirements.reportValidity()) {
        requirements.scrollIntoView({behavior:'auto', block:'center'});
        return;
      }
      nativePurchase.handleSubmit(event);
    };
    nativeForm.addEventListener('submit', event => event.preventDefault());
    root.querySelectorAll('[data-service-purchase-action]').forEach(button => {
      button.addEventListener('click', () => submitPurchase(button.dataset.servicePurchaseAction));
    });
  }
  requirements.addEventListener('submit', event => {
    event.preventDefault();
    if (nativeForm && purchaseSelection().approved) submitPurchase('add');
    else open();
  });
  root.querySelector('[data-open-quote]').addEventListener('click', open);
  document.querySelectorAll('[data-absen-service-trigger]').forEach(button => {
    if (button.dataset.absenServiceTrigger !== root.dataset.sectionId) return;
    button.addEventListener('click', event => { event.preventDefault(); open(); });
  });
  root.querySelectorAll('[data-close-dialog]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => { if(event.target === dialog) { const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close(); } });
  // Only the localhost review is blocked. Shopify retains its native contact submit/CAPTCHA/result.
  if (root.closest('[data-local-review]')) contact.addEventListener('submit', event => {
    event.preventDefault(); const status = root.querySelector('[data-submit-status]');status.hidden=false;
    status.textContent='Local preview only — this inquiry has not been sent. Delivery will be tested on the unpublished Shopify preview after approval.';
  });
  if(contact.querySelector('.errors') || contact.querySelector('[role="status"]:not([hidden])')) dialog.showModal();
  update();
});

// Native anchor navigation; no extra scroll loop or animation runtime.
document.querySelectorAll('[data-service-nav]').forEach(nav => {
  const links = [...nav.querySelectorAll('a[href^="#"]')];
  const updateCurrent = () => {
    const current = links.find(link => link.hash === location.hash) || links[0];
    links.forEach(link => {
      link.classList.toggle('is-active', link === current);
      if (link === current) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  window.addEventListener('hashchange', updateCurrent);
  updateCurrent();
});
